import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import "./assets/css/reset.css";
import "./assets/css/App.css";
import Email from "./components/Email";
import Phone from "./components/Phone";
import CallCenterPhone from "./components/CallCenterPhone";
import CallCenterEmail from "./components/CallCenterEmail";
import EmailVerify from "./components/EmailVerify";
import OTPVerify from "./components/OTPVerify";
import Logout from "./components/Logout";
import DeleteAccount from "./components/DeleteAccount";
import axios from "../node_modules/axios";
import CustomerDisplay from "./components/CustomerPortal";
import SessionExpired from "./components/SessionExpired";
import CustomerPortal from "./components/CustomerPortal";
import CryptoJS from "../node_modules/crypto-js";
import { ToastProvider } from "react-toast-notifications";
import EmailHR from "./components/EmailHR";

require("dotenv").config();

class App extends Component {
  constructor() {
    super();
    this.state = {
      access_token: "",
      apigee_access_token: "",
      password: "",
      salt: "",
    };
  }

  componentWillMount() {
    this.getAuthenticate();
  }

  async getAuthenticate() {
    var obj = {
      client_id: "SP_CLIENT_ID",
      client_secret: "SP_CLIENT_SECRET",
      grant_type: "client_credentials",
      resource: "RESOURCE",
      url: "AZURE_TENANT_ID",
    };
    try {
      const response = await axios({
        url: "/authenticate/token",
        method: "POST",
        data: obj,
      });
      let bytes = CryptoJS.AES.decrypt(
        response.data,
        process.env.REACT_APP_DPR_KVAULT_ENCRYPT
      );
      let decryptRes = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      this.setState({ access_token: decryptRes.access_token });
      this.fetchCryptPassword();
    } catch (e) {
      console.log(e);
    }
  }

  async fetchCryptPassword() {
    var encrypt_access_token = CryptoJS.AES.encrypt(
      this.state.access_token,
      process.env.REACT_APP_DPR_KVAULT_ENCRYPT
    ).toString();
    var obj = {
      access_token: encrypt_access_token,
      client_id: "REACT_APP_DPR_ENCRYPT_PASSWORD",
      request_var: "cryptPassword",
    };
    try {
      const response = await axios({
        url: "clientid/keyvault",
        method: "POST",
        data: obj,
      });
      let bytes = CryptoJS.AES.decrypt(
        response.data,
        process.env.REACT_APP_DPR_KVAULT_ENCRYPT
      );
      let decryptRes = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      this.setState({ password: decryptRes });
    } catch (e) {
      console.log(e);
    }
    this.fetchCryptSalt();
  }

  async fetchCryptSalt() {
    var encrypt_access_token = CryptoJS.AES.encrypt(
      this.state.access_token,
      process.env.REACT_APP_DPR_KVAULT_ENCRYPT
    ).toString();
    var obj = {
      access_token: encrypt_access_token,
      client_id: "REACT_APP_DPR_ENCRYPT_SALT",
    };
    try {
      const response = await axios({
        url: "clientid/keyvault",
        method: "POST",
        data: obj,
      });
      let bytes = CryptoJS.AES.decrypt(
        response.data,
        process.env.REACT_APP_DPR_KVAULT_ENCRYPT
      );
      let decryptRes = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      this.setState({ salt: decryptRes });
    } catch (e) {
      console.log(e);
    }
    this.getApigeeClientId();
  }

  async getApigeeClientId() {
    var encrypt_access_token = CryptoJS.AES.encrypt(
      this.state.access_token,
      process.env.REACT_APP_DPR_KVAULT_ENCRYPT
    ).toString();
    var obj = {
      access_token: encrypt_access_token,
      client_id: "REACT_APP_AT_CLIENT_ID",
      request_var: "apigeeClientId",
    };
    try {
      const response = await axios({
        url: "clientid/keyvault",
        method: "POST",
        data: obj,
      });
      let bytes = CryptoJS.AES.decrypt(
        response.data,
        process.env.REACT_APP_DPR_KVAULT_ENCRYPT
      );
      let decryptRes = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      if (decryptRes === "success") {
        this.getApigeeClientSecret();
      }
    } catch (e) {
      console.log(e);
    }
  }

  async getApigeeClientSecret() {
    var encrypt_access_token = CryptoJS.AES.encrypt(
      this.state.access_token,
      process.env.REACT_APP_DPR_KVAULT_ENCRYPT
    ).toString();
    var obj = {
      access_token: encrypt_access_token,
      client_id: "REACT_APP_AT_CLIENT_SECRET",
      request_var: "apigeeClientSecret",
    };
    try {
      const response = await axios({
        url: "clientid/keyvault",
        method: "POST",
        data: obj,
      });
      let bytes = CryptoJS.AES.decrypt(
        response.data,
        process.env.REACT_APP_DPR_KVAULT_ENCRYPT
      );
      let decryptRes = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      if (decryptRes === "success") {
        this.getApigeeAccessToken();
      }
    } catch (e) {
      console.log(e);
    }
  }

  async getApigeeAccessToken() {
    var obj = {
      grant_type: "client_credentials",
      url: "REACT_APP_AT_URL",
      client_id: "REACT_APP_APIGEE",
    };
    try {
      const response = await axios({
        url: "/authenticate/token",
        method: "POST",
        data: obj,
      });
      let bytes = CryptoJS.AES.decrypt(
        response.data,
        process.env.REACT_APP_DPR_KVAULT_ENCRYPT
      );
      let decryptRes = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      this.setState({ apigee_access_token: decryptRes });
    } catch (e) {
      console.log(e);
    }
  }

  render() {
    return (
      <ToastProvider>
        <div className="app">
          <Switch>
            <Route exact path="/" component={() => <Redirect to="/email" />} />
            <Route
              exact
              path="/email"
              render={(props) =>
                this.state.password ? (
                  <Email password={this.state.password} />
                ) : (
                  ""
                )
              }
            />
            <Route
              path="/phone"
              render={(props) =>
                this.state.password ? (
                  <Phone password={this.state.password} />
                ) : (
                  ""
                )
              }
            />
            <Route
              path="/close_account"
              render={(props) =>
                this.state.password ? (
                  <DeleteAccount password={this.state.password} />
                ) : (
                  ""
                )
              }
            />
            <Route
              path="/call-center-email"
              render={(props) =>
                this.state.password ? (
                  <CallCenterEmail password={this.state.password} />
                ) : (
                  ""
                )
              }
            />
            <Route
              path="/call-center-phone"
              render={(props) =>
                this.state.password ? (
                  <CallCenterPhone password={this.state.password} />
                ) : (
                  ""
                )
              }
            />
            <Route
              path="/email-verify"
              render={(props) =>
                this.state.salt ? (
                  <EmailVerify
                    {...props}
                    access_token={this.state.access_token}
                    password={this.state.password}
                    salt={this.state.salt}
                  />
                ) : (
                  ""
                )
              }
            />
            <Route
              path="/otp-verify"
              render={(props) =>
                this.state.salt ? (
                  <OTPVerify
                    {...props}
                    access_token={this.state.access_token}
                    logout={this.logout}
                    password={this.state.password}
                    salt={this.state.salt}
                  />
                ) : (
                  ""
                )
              }
            />
            <Route
              path="/customer-portal"
              render={(props) =>
                this.state.password ? (
                  <CustomerPortal {...props} password={this.state.password} salt={this.state.salt} />
                ) : (
                  ""
                )
              }
            />
            <Route
              path="/session-expired"
              render={(props) => <SessionExpired {...props} />}
            />
            <Route path="/logout" render={(props) => <Logout {...props} />} />
            <Route
              path="/email-request-confirm"
              render={(props) =>
                this.state.salt ? (
                  <EmailHR
                    {...props}
                    access_token={this.state.access_token}
                    password={this.state.password}
                    salt={this.state.salt}
                  />
                ) : (
                  ""
                )
              }
            />
          </Switch>
        </div>
      </ToastProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// src/App.js